import { collection, deleteDoc, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { collectionPath } from "../context/EnvContext";
import { useFirestore } from "../firebase/FirestoreContext";
import { useEffect, useState } from "react";

class DocumentNotFoundError extends Error {
  constructor(message) {
    super(message);
    this.name = 'DocumentNotFoundError';
  }
}

export async function getUserDocuments({ user, firestore, path, userKey = 'user_uid' }, ...rest) {
  const usageCollection = collection(firestore, `${collectionPath}${path}`);

  const docQuery = query(
    usageCollection,
    ...[where(userKey, "==", user.uid), ...rest],
  );

  return getDocs(docQuery);
}

export async function getDocument({ firestore, path, id }) {
  const ref = doc(firestore, `${collectionPath}${path}`, id);
  const snapshot = await getDoc(ref);

  const destroy = async () => {
    return deleteDoc(ref);
  }
  return {
    data: snapshot.data(),
    exists: snapshot.exists,
    destroy,
  };
}

export async function getDocuments({ firestore, path }, ...rest) {
  const usageCollection = collection(firestore, `${collectionPath}${path}`);

  const docQuery = query(
    usageCollection,
    ...rest
  );

  return getDocs(docQuery);
}

export async function getUserDocument(options, ...rest) {
  const snapshot = await getUserDocuments(options, ...rest);
  if (snapshot.empty) {
    throw new DocumentNotFoundError(`${options.path}: ${JSON.stringify(rest)}`);
  }

  return snapshot.docs[0];
}

export default function useDocuments(path, ...rest) {
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({ documents: [], snapshot: undefined });
  const firestore = useFirestore();

  useEffect(() => {
    async function fetch() {
      setIsLoading(true);
      const docQuery = query(
        collection(firestore, `${collectionPath}${path}`),
        ...rest
      );

      const snapshot = await getDocs(docQuery);

      const documents = snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() }));
      setState({ documents, snapshot });
      setIsLoading(false);
    }

    fetch();
  }, [path, rest.length]);

  return { ...state, isLoading };
}
